import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router';
import ConfigMembershipCardsHeader from '../../Components/Membership/ConfigMembershipCardsHeader';
import ConfigMembershipCreateNewCard from './ConfigMembershipCreateNewCard';
import styles from './ConfigMembershipCards.module.css';

const ConfigMembershipCards = (props) => {
    const { activeTab } = useParams();
    const { membershipIdentifier } = props

    return (
        <div className={styles.mainWrapper}>
            <div className={styles.mainContainer}>
                <ConfigMembershipCreateNewCard  />
            </div>
        </div>
    );
};

export default ConfigMembershipCards;
